import { render, staticRenderFns } from "./wt-auto-complete.vue?vue&type=template&id=435b3ae7"
import script from "./wt-auto-complete.vue?vue&type=script&lang=js"
export * from "./wt-auto-complete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports